<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  >

    <template #subHeaderActions>
      <div class="d-flex align-items-center gap-2 gap-lg-3">
        <Button v-if="canApprove && $can(abilities.APPROVED_EXPENSE)" btn-class="me-2 mb-2 btn-sm" backgroundColor="#2DA333" @click.prevent="approveExpense" type="new" btn-text="expenses.approve" />
        <Button v-if="canValidate && $can(abilities.VALIDATE_EXPENSE)"    btn-class="me-2 mb-2 btn-sm" backgroundColor="#2DA333" @click.prevent="validateExpense" type="new" btn-text="expenses.validate" />
        <Button v-if="canReject && $can(abilities.REJECT_EXPENSE)" btn-class="me-2 mb-2 btn-sm" backgroundColor="#E51335"  @click.prevent="rejectExpense" type="new" btn-text="expenses.reject" />
        <Button v-if="canPaid && $can(abilities.PAID_EXPENSE)" btn-class="me-2 mb-2 btn-sm" backgroundColor="#2DA333"  @click.prevent="paidExpense" type="new" btn-text="expenses.paid" />
        <Button icon-class="fas fa-backspace" btn-class="btn-sm mb-2" type="cancel" btn-text="crm.back" @click="router.go(-1)"/>
      </div>
    </template>
    

    <template #customLayoutContent>
      <div class=" m-10">
        <Loader :isLoading="isLoading">
          <div class="row d-flex flex-wrap px-5">
            <div v-if="[expenseStatusEnums.PARTIALLY_PAID, expenseStatusEnums.PAID, expenseStatusEnums.VALIDATED].includes(expense.status)" class="card p-5 mb-4 me-md-5 flex-grow-1 col-12 col-md-3 col-lg-3">
              <Card class="p-5">
                <div class="d-flex justify-content-between align-items-center py-4">
                  <span class="fw-bold fs-4"> {{ $t('expense.amountToCashOut') }} </span>
                  <span class="fw-bold fs-4"> {{ $formatLocalAmount(expense.fees_sum_amount) }} {{ expense.currency?.symbol }} </span>
                </div>
                <div class="separator" />
                <div class="d-flex justify-content-between align-items-center py-4">
                  <span class="fw-bold text-primary fs-4"> {{ $t('expense.remainToPay') }} </span>
                  <span v-if="expense.status === expenseStatusEnums.PARTIALLY_PAID" class="fw-bold text-primary fs-4"> {{ $formatLocalAmount(expense.remaining) }} {{ expense.currency?.symbol }} </span>
                  <span v-else-if="expense.status === expenseStatusEnums.VALIDATED" class="fw-bold text-primary fs-4"> {{ $formatLocalAmount(expense.fees_sum_amount) }} {{ expense.currency?.symbol }} </span>
                  <span v-else class="fw-bold text-primary fs-4"> {{ $formatLocalAmount("0") }} {{ expense.currency?.symbol }} </span>
                </div>
              </Card>
              <Card v-if="expense.motif && expense.status === expenseStatusEnums.REJECTED" class="card p-5 mt-auto">
                <h3 class="text-danger"> {{ $t('expense.rejectReason') }} </h3>
                <p class="fs-4"> {{ expense.motif }} </p>
              </Card>
            </div>
            <div class="card card-px-0 px-0 flex-grow-3 flex-md-grow-1 col-12 col-md-3 col-lg-3" style="flex: 1 1 60%;">
                <Show :expense="expense" :currency="currency"/>
            </div>
          </div>
        </Loader>
       
      </div>
      <RejectExpenseModal id="reject_expense" :callback="loadExpense"/>
      <PaidExpenseModal id="paid_expense" @reload="loadExpense"/>
    </template>
   

  </SubLayout>
</template>

<script setup> 
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import Loader from "@/components/Loader";
import {onMounted, ref, computed} from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import Show from "../Expense/components/Show.vue"
import { useSwal } from "@/composables/useSwal";
import { useExpenseEnums } from "../../composables/expenseEnums";
import Button from "@/components/Button.vue";
import RejectExpenseModal from "./components/RejectExpenseModal.vue";
import PaidExpenseModal from "@/Modules/Financial/views/Accounting/components/PaidExpenseModal.vue";
import Ls from "@/services/ls";
import abilities from "@/composables/abilities";
import {$formatLocalAmount} from "@/mixins/Helpers";
import Card from "@/components/Card.vue";

const route = useRoute()
const router = useRouter()

const store = useStore()
const {showSwal} = useSwal()
const { expenseStatusEnums } = useExpenseEnums()
const currentCompany = Ls.get('current.company')

const title = ref("breadcrumbs.expenses.title")

const breadcrumbs = ref([
  {
    name: 'breadcrumbs.expenses.expenseDetails',
    path: ''
  }
])

const isLoading = ref(false)

const expense = computed(() => store.getters['expenses/currentExpense'])
const currency = computed(() => expense.value?.currency?.symbol)
const company = computed(() => store.getters['company/getCompanyInfos'])

const canApprove = computed(() => {
  return expense.value.status === expenseStatusEnums.value.UNVALIDATED
})

const canValidate = computed(() =>  {
  return expense.value.status === expenseStatusEnums.value.APPROVED
})

const canReject = computed(() =>  {
  return [expenseStatusEnums.value.UNVALIDATED,expenseStatusEnums.value.VALIDATED,expenseStatusEnums.value.APPROVED].includes(expense.value.status)
})
const canPaid = computed(() =>  {
  return expense.value.status === expenseStatusEnums.value.VALIDATED || expense.value.status === expenseStatusEnums.value.PARTIALLY_PAID
})

async function loadExpense(){
  await store.dispatch('expenses/getExpensesById', route.params.id)
}
async function loadAccount () {
  await store.dispatch('accounts/loadAccountsForCountry',currentCompany)
}

 function loadBoxe () {
   store.dispatch('accounts/loadBoxesForOffice',expense.value.office.id)
}


async function loadData () {
  Promise.all([
     loadExpense()
  ]).then(() =>  loadBoxe())

}

function approveExpense() {
  showSwal(
      i18n.global.t('swal.approve'),
      i18n.global.t('swal.approve_text') 
  ).then( async (result) => {
    if (result.value) {
      store.dispatch('expenses/approveExpense', route.params.id)
          .then(() => {
            loadExpense()
            window.toastr['success'](i18n.global.t('notification.expense_validated'))
          })
          .catch(() => {
          })
          .finally(() => {})
    }
  })
}
function paidExpense() {
  $("#paid_expense").modal('toggle');
}
function validateExpense() {
  showSwal(
      i18n.global.t('swal.validate'),
      i18n.global.t('swal.validate_text') 
  ).then( async (result) => {
    if (result.value) {
      store.dispatch('expenses/validateExpense', route.params.id)
          .then(() => {
            loadExpense()
            window.toastr['success'](i18n.global.t('notification.expense_validated'))
          })
          .catch(() => {
          })
          .finally(() => {})
    }
  })
}
function rejectExpense() {
  showSwal(
      i18n.global.t('swal.reject'),
      i18n.global.t('swal.reject_text')
  ).then( async (result) => {
    if (result.value) {
      $("#reject_expense").modal('toggle');

    }
  })
}

onMounted(  () => {
   loadData()
   loadAccount()
})

</script>
